import { practiceAreas } from '@/data/practiceAreas';
import PracticeAreaTemplate from '@/components/PracticeAreaTemplate';

export default function MatrimonialPage() {
  return <PracticeAreaTemplate practiceArea={practiceAreas.matrimonial} />;
}
